import React, { useEffect, useState } from "react";
import InventoryTable from "../../Utills/Table/InventoryTable";
import axios from "axios";
import Switch from "@mui/material/Switch";
import Inventory from "../../components/Modal/Inventory/Inventory";

const ProductPage = ({ check, change }) => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [inventory, setInventory] = useState([]);

  useEffect(() => {
    if (loading) {
      axios
        .get("https://tsetsegtuw.templateapi.xyz/item")
        .then((e) => setInventory(e.data.data))
        .catch((e) => console.log(e))
        .finally(() => setLoading(false));
    }
  }, [loading]);

  if (loading) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-start min-h-screen ml-[18vw] w-[80vw] p-6">

      <div className="w-full flex justify-end mb-4">
        <Switch
          checked={check}
          onChange={change}
          inputProps={{ "aria-label": "controlled" }}
        />
        <Inventory />
      </div>
      <div className="w-full max-w-7xl">
        <InventoryTable inventories={inventory} />
      </div>
    </div>
  );
};

export default ProductPage;
